import { httpRequest } from "../../../utils/HttpRequest";
import { ISearchPage, IPage } from "@/types/FmsTypes";
import { LONG_REQUEST_TIMEOUT } from "@/utils/constants";

//详情
export interface IRealDetail {
    amount:string,   // 5
    code:string,   // null
    createTime:string,   // [2021, 8, 27, 15, 45, 37]
    createUser:string,   // "杨月"
    deleteFlag:string,   // 0
    ending:string,   // 5
    endingNum:string,   // 5
    id:string,   // "1"
    liveAmount:string,   // 5
    liveNum:string,   // 5
    num:string,   // 5
    openingAmount:string,   // 0
    openingNum:string,   // 0
    orderNum:string,   // 0
    shopCode:string,   // "s01"
    shopName:string,   // "法士特"
    tradeCode:string,   // "cg001"
    tradeTypeCode:string,   // "01"
    tradeTypeName:string,   // "采购"
    updateTime:string,   // [2021, 8, 27, 15, 45, 37]
    updateUser:string,   // null
    warehouseCode:string,   // "fasit"
    warehouseName:string,   // "法士特仓库"
}


//搜索条件
export interface IRealSearchFields {

}

export interface IRealSearch
    extends IRealSearchFields, ISearchPage {
}


class RealService {
    async page(searchVo: IRealSearch) {
        const apiUrl = "/invoiceChange/live/page";
        return await httpRequest.post1<IPage<IRealDetail>>(apiUrl, searchVo);
    }
    //导出
    async export(searchVo: IRealSearch) {
        const apiUrl = "/invoiceChange/live/export";
        return await httpRequest.postFile<boolean>(apiUrl, searchVo, { timeout: LONG_REQUEST_TIMEOUT });
    }
}

export const realService = new RealService();
